//src/pages/calendar/calendar.jsx
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Tabs from "../tabs";
import BasicModal from "../../components/BasicModal";
import { STANDARD_FORM_MODAL_MAX_HEIGHT } from "../../utils/formModalStyles";
import { getPatientById } from "../../services/patientService";

const computeAge = (dob) => {
  if (!dob) return null;
  const parsed = new Date(dob);
  if (Number.isNaN(parsed.getTime())) return null;
  return Math.max(0, Math.floor((Date.now() - parsed.getTime()) / (365.25 * 24 * 60 * 60 * 1000)));
};

const Calendar = ({ open, onClose, appointment }) => {
  const [patient, setPatient] = useState(null);
  const patientId = appointment?.patientId;

  useEffect(() => {
    if (!open || patientId == null || patientId === "") {
      setPatient(null);
      return;
    }
    let cancelled = false;
    getPatientById(patientId)
      .then((data) => {
        if (!cancelled) setPatient(data || null);
      })
      .catch(() => {
        if (!cancelled) setPatient(null);
      });
    return () => {
      cancelled = true;
    };
  }, [open, patientId]);

  const displayId = patient?.id ?? patientId ?? "N/A";
  const displayName = patient?.name || appointment?.patientName || "N/A";
  const displayAge = computeAge(patient?.dob) ?? "N/A";
  const displayMobile = patient?.mobile || patient?.phone || appointment?.patientMobile || "N/A";
  const rawType = String(patient?.patientType || patient?.patient_type || "").trim().toUpperCase();
  const displayType = rawType === "OUT" ? "Out Patient" : rawType === "IN" ? "In Patient" : rawType || "N/A";

  const title = `ID : ${displayId} | ${displayName} | ${displayAge} yrs | Ph : ${displayMobile} | ${displayType}`;

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      titleSx={{ fontWeight: "bold", fontSize: "18px" }}
      title={title}
      sx={{
        width: "90%",
        maxWidth: "1200px",
        // Fixed (not just capped) height so the modal doesn't reflow/shrink when switching
        // between tabs with different amounts of content (e.g. Add New Record vs Patient
        // History) — shorter tabs just leave blank space instead of resizing the dialog.
        height: STANDARD_FORM_MODAL_MAX_HEIGHT,
        maxHeight: STANDARD_FORM_MODAL_MAX_HEIGHT,
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      <Box display="block" m="1px">
        <Tabs appointment={appointment} onClose={onClose} patient={patient} />
      </Box>
    </BasicModal>
  );
};

export default Calendar;
